import Cookies from 'js-cookie'
import { Navigate, Outlet, useLocation } from 'react-router-dom'

function Root() {
  const location = useLocation()
  const loginToken = Cookies.get('LoginToken')
  const isLoginPage = location.pathname === '/login'
  const isForgotPasswordPage = location.pathname === '/forgot-password'

  if (!loginToken && !isLoginPage && !isForgotPasswordPage) {
    return <Navigate replace to='/login' />
  }

  if (loginToken && (location.pathname === '/' || location.pathname === '' || isLoginPage || isForgotPasswordPage)) {
    return <Navigate replace to='/dashboard' />
  }

  return <Outlet />
}

export default Root
